<template>
  <div class="management-system-wrapper">
    <Header class="header"></Header>
    <div class="management-system">
      <main-sidebar />
      <div class="content">
        <!-- <keep-alive> -->
          <router-view/>
        <!-- </keep-alive> -->
      </div>
    </div>
  </div>
</template>

<script>
  import MainSidebar from './main-sidebar'
  import MainContent from './main-content'
  import Header from './header.vue'
  export default {
    data () {
      return {
        loading: true
      }
    },
    components: {
      MainSidebar,
      MainContent,
      Header
    },
    computed: {
      documentClientHeight: {
        get () { return this.$store.state.common.documentClientHeight },
        set (val) { this.$store.commit('common/updateDocumentClientHeight', val) }
      },
      sidebarFold: {
        get () { return this.$store.state.common.sidebarFold }
      },
      userId: {
        get () { return this.$store.state.user.id },
        set (val) { this.$store.commit('user/updateId', val) }
      }
    },
    mounted () {
      this.resetDocumentClientHeight()
    },
    methods: {
      // 重置窗口可视高度
      resetDocumentClientHeight () {
        this.documentClientHeight = document.documentElement['clientHeight']
        window.onresize = () => {
          this.documentClientHeight = document.documentElement['clientHeight']
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.management-system-wrapper{
  height: 100%;
  display: flex;
  flex-direction: column;
  .header{
    flex: 0 0 80px;
  }
  .management-system {
    //flex-grow: 1;
    display: flex;
    height: calc(100% - 80px);
    position: relative;
    .content {
      overflow: hidden;
      flex-grow: 1;
      position: relative;
      background: #F0F0F0;
    }
  }
}
</style>